import Image from 'next/image'
import { type FC } from 'react'

import { Button } from '@wartek-id/button-v1'
import type { DialogProps } from '@wartek-id/dialog-v1'
import { Dialog, DialogContent, DialogOverlay } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'

type TProps = Omit<DialogProps, 'children'> & {
  count?: number
  onClick: () => void
}

const DialogDeliverySuccessTahunan: FC<TProps> = ({
  count = 0,
  onClick = () => {},
  ...props
}) => {
  return (
    <Dialog data-module="pengelolaan-kinerja" {...props}>
      <DialogOverlay />
      <DialogContent className="!rounded-lg">
        <div className="p-6 space-y-2">
          <Image
            alt=""
            src="/illustrations/img-thumbs-up.png"
            width={84}
            height={84}
          />
          <Text variant="display-sm">
            {count} Predikat Kinerja (Tahunan) sudah dikirim ke Pegawai
          </Text>

          <Text variant="body-lg" color="subdued">
            Anda dapat melanjutkan pengiriman Predikat Kinerja (Tahunan) jika
            ada yang belum dikirim. Mohon cek secara berkala.
          </Text>

          <div className="flex gap-5 !mt-4">
            <Button size="lg" data-testid="btn-confirm" onClick={onClick}>
              Saya mengerti
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
export default DialogDeliverySuccessTahunan
